export default __webpack_public_path__ + "static/media/buy-sell.1e7b244c.svg";